<template>
  <v-chip v-bind="$attrs" :style="chipStyle" >
    {{label}}
  </v-chip>
</template>

<script>
import colorMixin from "@/components/mixins/ColorMixin";

export default {
  name: "PrestaIssueStatusChip",
  mixins: [colorMixin],
  props: {
    value: { type:String, default: 'in_progress' } // 'in_progress' | 'give_up' | 'closed'
  },
  inheritAttrs: false,
  computed: {
    config() {
      return this.prestationIssueStatusColors(this.value) || this.prestationIssueStatusColors('in_progress')
    },
    label() {
      return this.config.label
    },
    chipStyle() {
      return {
        backgroundColor: this.config.backgroundHex,
        color: this.config.colorHex
      }
    }
  },
}
</script>


<style scoped>

</style>